import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let AddressDesign = class AddressDesign extends Vue {
    render(h) {
        let opts = {
            props: {
                disabled: true,
                placeholder: "请选择"
            }
        };
        let child = [
            h("a-input", opts, [
                h("i", {
                    props: {
                        type: "user"
                    },
                    slot: 'suffix',
                    'class': [
                        'aufontAll',
                        'h-icon-all-down-o'
                    ]
                })
            ])
        ];
        const { addressDetail } = this.control.options;
        if (addressDetail === 'true') {
            const _opts = Object.assign(opts);
            _opts.props.placeholder = this.$t('cloudpivot.form.renderer.peleseInput');
            child.push(h("a-textarea", _opts));
        }
        return h("div", {
            class: 'address'
        }, child);
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], AddressDesign.prototype, "control", void 0);
AddressDesign = tslib_1.__decorate([
    Component({ name: 'AddressDesign' })
], AddressDesign);
export default AddressDesign;
